t = require('views/internal/teacup-with-helpers')('tip_help')

module.exports = t.renderable ({ title, description, imgUrl1x, imgUrl2x, url, buttonText }) ->
  t.div '.tip-help.hide', ->
    t.div '.tip-help-image', ->
      t.div '.tip-help-image-button.tip-help-image-button-previous.js-tip-help-previous', ->
        t.icon 'down'
      t.img '.tip-help-image-img', {
        src: imgUrl1x
        srcset: "#{ imgUrl1x } 1x, #{ imgUrl2x } 2x"
      }
      t.div '.tip-help-image-button.tip-help-image-button-next.js-tip-help-next', ->
        t.icon 'down'
    t.h2 '.tip-help-title', title
    t.p '.tip-help-description', description
    if buttonText
      t.a '.button-link.primary.tip-help-button.js-tip-help-button', {
        href: url,
        target: '_blank'
      }, buttonText



// WEBPACK FOOTER //
// ./app/scripts/views/templates/tip_help.coffee